// extracted by mini-css-extract-plugin
export default {"favoriteIcon":"ToggleFavoriteIcon_favoriteIcon__wcJJ1"};